export const conflictingSources: string[] = [
  'One video explains a Class II preparation.',
  'A textbook chapter covers radiographic anatomy.',
  'A slide deck from years ago explains probing.',
  'Your old notes cover the inferior alveolar nerve block.',
]

export const symptoms: string[] = [
  'And when you need material for anatomy, diagnosis, restorative, endo, perio, oral surgery or lesson planning...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next lecture or clinical session arrives.'

export const needsList: string[] = [
  'You need a clear visual of the structure, the instrument or the technique.',
  'You need the procedure broken down step by step.',
  'You need simulation drills that actually engage your students.',
  'You need ❌/✅ comparisons that correct common clinical errors.',
  'And you need a clear way to see who is really ready for the next clinical step.',
]

export const searchQuestions: string[] = [
  'What should I teach in today’s session?',
  'How do I explain tooth morphology so students can actually identify every tooth?',
  'How do I teach radiograph interpretation step by step?',
  'How do I correct a preparation that keeps going wrong?',
  'Which typodont drills fit this group of students?',
  'How do I give feedback without discouraging anyone?',
  'Where do I find clear visual material for endo, perio and oral surgery?',
  'How can I plan better sessions without spending hours every week?',
]

export const painPoints: string[] = [
  'Rebuilding lectures and lab sessions from scratch every week.',
  'Hours searching scattered textbooks, slides, videos and notes.',
  'Explaining anatomy, procedures and materials with words alone.',
  'Students memorizing steps without understanding why.',
  'No visual material for simulation labs and chairside teaching.',
  'Repeating the same corrections every session.',
  'Assessing competencies without clear criteria.',
  'Losing time you could spend actually teaching.',
  'And constantly wondering if your next session will be good enough.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO CORRECT ERRORS.',
  'HOW TO STRUCTURE THE SESSION.',
  'HOW TO ASSESS COMPETENCY.',
]
